import React, { useState, useEffect } from "react";
import { isMobile } from "@/utils/public";
import Home from "./home";
import Mcpdy from "./mcpdy";
import Mcpsj from "./mcpsj";

function Mcp() {
  const isMob = isMobile();
  const [tab, setTab] = useState("home");
  const tabs = [
    {
      label: "首页",
      key: "home",
    },
    {
      label: "mcp调用",
      key: "mcpdy",
    },
    {
      label: "mcp上架",
      key: "mcpsj",
    },
  ];

  return (
    <div className="zdSearch">
      <div className="mxgcHeader">
        <div
          className="title"
          style={{
            padding: isMob ? "0 24px 0 28px" : "0 35px",
          }}
        >
          MCP广场
        </div>
        <div
          className="tabs"
          style={{
            paddingRight: isMob ? "unset" : "40px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            {tabs.map((item) => {
              return (
                <div
                  className="tabItem"
                  style={{
                    borderBottom:
                      tab === item.key ? "3px solid #1E5BCE" : "unset",
                    color: tab === item.key ? "#1E5BCE" : "unset",
                    cursor: "pointer",
                    padding: isMob ? "0 6px" : "0 10px",
                  }}
                  onClick={() => {
                    setTab(item.key);
                  }}
                >
                  {item.label}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {tab === "home" ? <Home /> : undefined}
      {tab === "mcpdy" ? <Mcpdy /> : undefined}
      {tab === "mcpsj" ? <Mcpsj /> : undefined}
    </div>
  );
}

export default Mcp;
